    <p-toast position="bottom-right"></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <app-archive-sidebar>
      <app-report-tasks-table body [transPartKey]="transPartKey" [origins]="origins"></app-report-tasks-table>
    </app-archive-sidebar>

